/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { UserContext } from '../../../contexts/User';
import PlanSelector from '../../../components/PlanSelector';

function Plans({ onSubscriptionSuccess }) {
  const { activeWorkspace } = useContext(UserContext);
  const location = useLocation();

  // Check if we're in renewal context
  const searchParams = new URLSearchParams(location.search);
  const isRenewing = searchParams.get('renew') === 'true';

  return (
    <div style={{ paddingTop: 24, paddingBottom: 24 }}>
      <PlanSelector
        activeWorkspace={activeWorkspace}
        context="settings"
        isRenewing={isRenewing}
        onSubscriptionSuccess={onSubscriptionSuccess}
      />
    </div>
  );
}

Plans.propTypes = {
  onSubscriptionSuccess: PropTypes.func,
};

export default Plans;
